import useTheme from '@/composables/ui/useTheme';

const { getMerchTheme } = useTheme();

export default function PrefetchScripts() {
	getMerchTheme();
}
